import { PdfGen } from '../pdf/pdf';
import { OptsLabelText } from './optsLabelText';

export const ILayoutLabelTextSymbol = Symbol('LayoutLabelText');

export interface ILayoutLabelTextGen {
  generate(pdf: PdfGen, opts: OptsLabelText): Promise<void>;
}
